import { LoginModal } from "../../../components";
import RegistrationModal from "../../../components/RegistrationModal";
import { useAppSelector } from "../../../redux/hooks";
import {
  getCartState,
  getLoginModal,
  getRegistrationModal,
} from "../../../redux/selectors";
import { Header, Table } from "./components";

const Basket = () => {
  const cart = useAppSelector((state) => getCartState(state));
  return (
    <div>
      {cart.length == 0 ? (
        <div className="container">
          <h1 className="title">Вы пока ничего не выбрали из товаров</h1>
          <p>
            Ваш список пока пуст, выберите нужные и товары и добавьте в корзину
          </p>
        </div>
      ) : (
        <>
          <Header />
          <Table />
        </>
      )}
    </div>
  );
};

export default Basket;
